// By default, a react-dom module is exported; see code/main/* for other options
module.exports = require('./code/main/react-dom')


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon1/react.js
// module id = 430
// module chunks = 35783957827783